/**
 * Fetches the current cart data from the Shopify store.
 *
 * @returns {Promise<Object>} A promise that resolves to the cart data as a JSON object.
 */
const getCart = async () => {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch cart data:', error);
    return null;
  }
};

/**
 * Updates the cart icon in the header with the current item count.
 *
 * @param {number} count - The number of items in the cart.
 */
updateIconCartHeader = (count) => {
  const iconHeader = document.querySelectorAll('.header .header__cart-dot');

  iconHeader.forEach((icon) => {
    if (count > 0) {
      icon.classList.add('is-visible');
    } else {
      icon.classList.remove('is-visible');
    }
  });
}

/**
 * Event listener for the 'rebuy:cart.change' event, which updates the cart icon in the header
 * with the current item count after a short delay.
 *
 * @param {Event} e - The event object.
 */
document.addEventListener('rebuy:cart.change', function(e){
  setTimeout(async ()=>{
    let {item_count} = await getCart();
    updateIconCartHeader(item_count);
  },1000);
});
